module.exports = __webpack_public_path__ + "img/ic_24_play.30c7941d.svg";